import { useRecordContext } from 'react-admin';
import { makeStyles } from '@mui/styles';
import { FormLabel } from '@mui/material';

const useStyles = makeStyles({
  json: {
    fontSize: 10,
    maxWidth: 350,
    maxHeight: 140,
    overflowY: 'scroll',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
});

interface Props {
  source: string;
  fullWidth?: boolean;
  label?: string;
}

export const JsonField = ({ source, fullWidth, label }: Props) => {
  const classes = useStyles();
  const record = useRecordContext();
  const json = record[source];

  if (!record) {
    return null;
  }

  return (
    <div className={classes.json} style={{ maxWidth: fullWidth ? '100%' : undefined }}>
      <pre>
        {typeof json === 'string'
          ? json
          : isJson(json)
            ? JSON.stringify(json, null, 2)
            : ''}
      </pre>
    </div>
  );
};

const isJson = (obj: any) => {
  return Object.prototype.toString.call(obj) === '[object Object]' && !Array.isArray(obj);
};
